export default "__VITE_ASSET__BEsP1PSN__"